import tags from './tags'
import digitalForm from './digitalForm'
import formFields from './formFields'
import formFieldBlocks from './formFieldBlocks'

export default {
  namespaced: true,
  modules: {
    digitalForm,
    formFields,
    formFieldBlocks,
    tags
  }
}
